import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, SetVariantSelection } from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";

declare module "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection" {
    interface Parameter {
        traitSelections?: SafeDictionary<string>;
    }
}

const SetVariantSelectionExtended: typeof SetVariantSelection = props => {
    const parameter = props.parameter as typeof props.parameter & { traitSelections?: SafeDictionary<string> };

    if (parameter.traitSelections) {
        props.variantSelection = { ...props.variantSelection, ...parameter.traitSelections };
        return;
    }
    if (!parameter.variantTraitId) {
        return;
    }
    props.variantSelection[parameter.variantTraitId] = parameter.traitValueId;
};

replaceInChain(chain, SetVariantSelection, SetVariantSelectionExtended);